module.exports = __webpack_public_path__ + "static/img/14000099.a7a89988.png";